import { Navigate, Outlet } from '@tanstack/react-router';

import { useFeatureEnabledSuspense } from 'common/feature-flag/hooks/useFeatureEnabled';
import { useSelectedWarehouse } from 'common/hooks/useSelectedWarehouse';

/** There are still warehouses that rely on Wolt menu for inventory, and since the new ops-optimized receiving tool
does not support that use case, we need to have the legacy receiving tool available for those venues  */
const ReceivingEnabledRoute = () => {
  const { id: selectedWarehouseId } = useSelectedWarehouse();
  const isV1Venue = useFeatureEnabledSuspense('warehouse-v1-functionality', [selectedWarehouseId]);

  if (isV1Venue) {
    return <Outlet />;
  }

  return <Navigate to="/ops-receiving" />;
};

export default ReceivingEnabledRoute;
